import * as React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Emphasized,
    SelectSingle,
    YStack,
} from 'smoothie';

import type { UserReissueReason } from '../../../../types/Card';
import type { ReissueOption } from '../ReplaceCard';

interface ReplacementReasonProps {
    lostOrStolen: boolean;
    replacementReason: UserReissueReason | null;
    replacementOptions: ReissueOption[];
    onSelect: (replacementReason: string) => void;
    onPress: () => void;
}

const ReplacementReason = ({
    lostOrStolen,
    replacementReason,
    replacementOptions,
    onSelect,
    onPress,
}: ReplacementReasonProps) => {
    const submitEnabled =
        replacementReason != null &&
        replacementOptions
            .map((option) => option.value)
            .includes(replacementReason);

    const selectedIndex =
        replacementReason != null
            ? replacementOptions.findIndex(
                  (option) => option.value === replacementReason,
              )
            : null;

    return (
        <YStack flex={1} justifyContent="space-between">
            <YStack gap={6}>
                <H5Emphasized>
                    What is the reason for the replacement?
                </H5Emphasized>
                {!lostOrStolen && (
                    <BodyMediumRegular color="$gray1000">
                        We won&apos;t cancel your current card until you
                        activate your new one. You&apos;ll keep the same card
                        number and PIN.
                    </BodyMediumRegular>
                )}
                <YStack width="100%" marginTop={24} maxWidth={500}>
                    <SelectSingle
                        options={replacementOptions.map((option) => ({
                            title: option.description,
                        }))}
                        selectedIndex={selectedIndex ?? undefined}
                        onSelect={(index) => {
                            const selectedOption = replacementOptions[index];
                            if (selectedOption) {
                                onSelect(selectedOption.value);
                            }
                        }}
                    />
                </YStack>
            </YStack>
            <Button
                variant={ButtonVariant.PRIMARY}
                onPress={onPress}
                size={ButtonSize.LARGE}
                text="Next"
                disabled={!submitEnabled}
            />
        </YStack>
    );
};

export default ReplacementReason;
